import { IMultipleIdsParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { SubscriptionDataConditionType } from '../types/SubscriptionDataCondition';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetSubscriptionsDataConditionParams extends IMultipleIdsParams {
  dataConditionType: SubscriptionDataConditionType;
}

export class SetSubscriptionsDataConditionRequest extends Request<ISetSubscriptionsDataConditionParams, IEmptyResult> {
  constructor(params: ISetSubscriptionsDataConditionParams) {
    super('setSubscriptionsDataCondition', params);
  }
}
